// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zejZ","toggle":"styles_toggle__12wnN","preview":"styles_preview__2iUiZ"};